export default "__VITE_ASSET__DXpsafcZ__"